/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Settings_Category_Descriptionhelp1Inputs */

const en_cases_settings_category_descriptionhelp1 = /** @type {(inputs: Cases_Settings_Category_Descriptionhelp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vega Intelligence uses this description to decide which cases belong in this category.`)
};

/**
* | output |
* | --- |
* | "Vega Intelligence uses this description to decide which cases belong in this category." |
*
* @param {Cases_Settings_Category_Descriptionhelp1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cases_settings_category_descriptionhelp1 = /** @type {((inputs?: Cases_Settings_Category_Descriptionhelp1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Settings_Category_Descriptionhelp1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cases_settings_category_descriptionhelp1(inputs)
});
export { cases_settings_category_descriptionhelp1 as "cases_settings_category_descriptionHelp" }